import React from "react";
import Link from "../../../utils/link";
import BlogPageCard from "../AllBlog/BlogPageCard";

const RelatedBlogs = (projects) => {

    return (
        <section className="width pb-12 lg:pb-16">

            <div className="lg:hidden pb-10">
                <Link className='uppercase text-center bg-white border w-full border-green inline-block pt-4 pb-3' to="/contact/">
                    Contact Us
                </Link>


            </div>

            <h2 className="text-lg lg:text-3xl font-semibold pb-5 lg:pb-7 pt-4 lg:pt-0 border-t border-black lg:border-t-0">
                Related articles.
            </h2>
            <ol className="grid lg:grid-cols-2 gap-7 lg:gap-6">


                {
                    projects.projects.map(project => {
            
                        const content = project.content
                        if (content?.card_image?.filename == undefined || content?.card_image?.filename == '') return null
                        const firstTag = project.tag_list[0] || ""
                        const formattedDate = new Date(project.first_published_at)
                        // format to 04/03/23
                        const date = formattedDate.toLocaleDateString('en-GB', { month: 'numeric', day: 'numeric', year: '2-digit' }).replace(/\//g, '.')
                        return (
                            <li key={`related-project-${project.uuid}`}>
                                <BlogPageCard image={content.card_image} title={content.title} copy={content.tagline} url={project.full_slug} date={date} tag={firstTag} />

                            </li>
                        )
                    })
                }

                <li className="lg:hidden">
                    <Link className='uppercase text-center bg-white border w-full border-green inline-block pt-4 pb-3' to="/journal/">
                        See more articles
                    </Link>
                </li>

            </ol>

        </section>
    )
}

export default RelatedBlogs